import { createContext } from "react";
const noteContext=createContext();
//Syntax to create new context




export default noteContext;
//This folder will help in creating context